// src/components/Home.js
import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <main className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-badge">MEDICAL BILLING SERVICES</div>
          <h1 className="hero-title">
            Top Medical Billing Company <span className="highlight">in USA</span>
          </h1>
          <p className="hero-description">
            Oxymed Billing Solutions delivers end-to-end medical billing, coding and credentialing services 
            that help healthcare providers increase revenue 15 to 30% with accuracy, transparency, and full HIPAA compliance.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="stat-value">$30M</div>
              <div className="stat-label">SUCCESSFULLY BILLED</div>
            </div>
            <div className="hero-stat">
              <div className="stat-value">★</div>
              <div className="stat-label">ACCREDITED BUSINESS</div>
            </div>
            <div className="hero-stat">
              <div className="stat-value">✓</div>
              <div className="stat-label">HIPAA COMPLIANT</div>
            </div>
          </div>
          <button className="btn-contact">CONTACT US</button>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are-section">
        <div className="container">
          <div className="who-we-are-content">
            <div className="who-we-are-left">
              <div className="section-tag">WHO WE ARE</div>
              <h2 className="section-title-dark">
                Choose Oxymed Billing Solutions Because We Deliver
              </h2>
              <p className="who-we-are-text">
                At Oxymed Billing Solutions, we turn billing complexity into consistent revenue backed by 4+ years 
                of combined experience and a team that treats your practice like their own. Your financial health isn't 
                just a priority here, it's the whole point.
              </p>
              <p className="who-we-are-text">
                We bring specialty-focused expertise and cutting-edge technology to every client we serve so claims go out clean, 
                fewer denials come back, and reimbursements arrive faster. While you focus on delivering exceptional patient care, 
                we focus on making sure every dollar you earn actually reaches you.
              </p>
              <p className="who-we-are-text">
                Our specialists become a seamless extension of your team offering scalable, flexible support that grows with your 
                practice, with nationwide coverage that ensures you're never without expert billing help when it matters the most.
              </p>
              <div className="who-we-are-stats">
                <div className="stat-item">
                  <div className="stat-number">100+</div>
                  <div className="stat-desc">Combined Years of Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">15-30%</div>
                  <div className="stat-desc">INCREASED REVENUE</div>
                </div>
              </div>
            </div>
            <div className="who-we-are-right">
  <img 
    src={require('../assets/878.jpg')} 
    alt="Medical Billing Team"
    className="who-we-are-image"
  />
</div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="what-we-offer-section">
        <div className="container">
          <div className="section-header-center">
            <div className="section-tag-white">WHAT WE OFFER</div>
            <h2 className="section-title-white">
              Complete Medical Billing & RCM Services
            </h2>
            <p className="section-subtitle-white">
              As Oxymed Billing Solutions, we understand that every practice is unique. Your focus is on patients' care 
              while ensuring your financial health. We provide comprehensive, end-to-end Medical Billing Revenue Cycle 
              solutions designed to maximize reimbursement, reduce denials, and simplify medical billing.
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">📋</div>
              <h3 className="service-title">MEDICAL BILLING SERVICES</h3>
              <p className="service-description">Streamline your revenue cycle with our comprehensive billing solutions.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">✅</div>
              <h3 className="service-title">MEDICAL CREDENTIALING SERVICES</h3>
              <p className="service-description">Get your provider credentials quickly with payers and insurance networks.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💻</div>
              <h3 className="service-title">MEDICAL CODING SERVICES</h3>
              <p className="service-description">Our certified coders ensure precise and compliant coding for every specialty.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📊</div>
              <h3 className="service-title">DENIAL MANAGEMENT SERVICES</h3>
              <p className="service-description">We proactively identify, analyze, and resolve claim denials with precision.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💰</div>
              <h3 className="service-title">AR FOLLOW-UP SERVICES</h3>
              <p className="service-description">Our team monitors and manages aged accounts receivable with care.</p>
            </div>
          </div>
          <div className="view-all-container">
            <button className="btn-view-all">VIEW ALL SERVICES →</button>
          </div>
        </div>
      </section>
            {/* Why Choose Us Section */}
      <section className="why-choose-us-section">
        <div className="container">
          <div className="section-tag-center">WHY CHOOSE US</div>
          <h2 className="section-title-dark text-center">
            Empower Your Practice with Oxymed Billing Solutions
          </h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3 className="feature-title">DEDICATED ACCOUNT MANAGEMENT</h3>
              <p className="feature-description">
                Receive tailored guidance and hands-on support from an experienced account manager 
                committed to your practice's success.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💻</div>
              <h3 className="feature-title">SMART TECHNOLOGY INTEGRATION</h3>
              <p className="feature-description">
                Benefit from seamless integration with modern EHR, Practice Management (PM), and 
                advanced billing systems designed for efficiency and accuracy.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3 className="feature-title">STAY ALIGNED WITH INDUSTRY UPDATES</h3>
              <p className="feature-description">
                Strengthen your revenue cycle performance while confident in adapting to evolving 
                healthcare regulations and market demands.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3 className="feature-title">INSIGHTFUL REPORTING & ANALYTICS</h3>
              <p className="feature-description">
                Gain access to comprehensive, data-driven reports that uncover performance trends 
                and highlight opportunities to improve your operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* We Serve All Over USA Section */}
      <section className="we-serve-section">
        <div className="container">
          <div className="serve-header">
            <div className="serve-badge">WE SERVE ALL OVER USA</div>
            <h2 className="serve-title">
              Comprehensive Medical Billing Services <span className="highlight">Covering All of the USA</span>
            </h2>
            <p className="serve-description">
              Oxymed Billing Solutions, a trusted medical billing company in the USA, provides expert billing services 
              wherever your practice is located. We ensure accurate claims and timely payments, so you can focus on 
              quality patient care while we handle your billing.
            </p>
            <p className="serve-description-second">
              From Chicago to nationwide, Oxymed Billing Solutions delivers precise, reliable billing solutions that 
              enhance your practice's efficiency and financial performance. We're committed to supporting your success, 
              wherever you are.
            </p>
            <button className="btn-view-states">VIEW ALL STATES →</button>
          </div>
        </div>
      </section>

      {/* Practices We Serve Section */}
      <section className="practices-section">
        <div className="container">
          <div className="practices-header">
            <h2 className="practices-title">Practices We Serve</h2>
            <p className="practices-description">
              Oxymed Billing Solutions currently serves more than 2,000 providers. We partner with healthcare providers 
              across all specialties and practice sizes, helping clinics grow, scale, and get paid accurately and on time.
            </p>
          </div>
          <div className="practices-content">
            <div className="practices-left">
              <div className="practice-type-card">
                <h3 className="practice-type-title">Small, Mid, & Large Practice</h3>
                <ul className="practice-list">
                  <li>✓ Promote provider retention and growth.</li>
                  <li>✓ Deliver customized billing and CMS services that fit your needs.</li>
                  <li>✓ Reduce administrative burden, and improve cash flow.</li>
                </ul>
              </div>
            </div>
            <div className="practices-right">
              <div className="states-grid">
                <div className="states-column">
                  <ul className="states-list">
                    <li>New Jersey</li>
                    <li>New Mexico</li>
                    <li>Washington</li>
                    <li>Pennsylvania</li>
                    <li>Massachusetts</li>
                    <li>Connecticut</li>
                  </ul>
                </div>
                <div className="states-column">
                  <ul className="states-list">
                    <li>Texas</li>
                    <li>Illinois</li>
                    <li>Florida</li>
                    <li>Arizona</li>
                  </ul>
                </div>
                <div className="states-column">
                  <ul className="states-list">
                    <li>North Carolina</li>
                    <li>Ohio</li>
                    <li>South Carolina</li>
                    <li>Minnesota</li>
                    <li>New York</li>
                    <li>Mississippi</li>
                    <li>California</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="view-all-states-container">
            <button className="btn-view-all-states">View All States →</button>
          </div>
        </div>
      </section>
            {/* Specialties Section */}
      <section className="specialties-section">
        <div className="container">
          <div className="specialties-header">
            <h2 className="specialties-title">
              Oxymed Billing Solutions Covers All <span className="highlight">Medical Billing Specialties</span>
            </h2>
            <p className="specialties-description">
              We know that healthcare specialties are unique as the patients they serve. That's why we offer specialized 
              medical billing services that are custom-tailored to meet the specific needs of each specialty.
            </p>
          </div>
          <div className="specialties-grid">
            <div className="specialty-item">Mental Health</div>
            <div className="specialty-item">Podiatry</div>
            <div className="specialty-item">internal Medicine</div>
            <div className="specialty-item">Family Medicine</div>
            <div className="specialty-item">Home Health</div>
            <div className="specialty-item">Urgent Care</div>
            <div className="specialty-item">Cardiology</div>
            <div className="specialty-item">Ophthalmology</div>
            <div className="specialty-item">Nephrology</div>
            <div className="specialty-item">Dermatology</div>
            <div className="specialty-item">Neurosurgery</div>
          </div>
          {/* <div className="view-all-specialties-container">
            <button className="btn-view-all-specialties">VIEW ALL SPECIALTIES →</button>
          </div> */}
        </div>
      </section>

      {/* Trust Stats Section */}
      <section className="trust-stats-section">
        <div className="container">
          <div className="trust-header">
            <h2 className="trust-title">
              Here is Why <span className="highlight">2000+ Providers Trust Us!</span>
            </h2>
            <p className="trust-description">
              At Oxymed Billing Solutions, we go beyond traditional medical billing. Our expert knowledge and experience 
              allows us to increase collection, minimize claim denials, and keep your practice running efficiently so you 
              can focus on delivering exceptional patient care.
            </p>
          </div>
          <div className="stats-grid-2">
            <div className="stat-card-2">
              <div className="stat-number-2">98.71%</div>
              <div className="stat-label-2">Clean Claims Submission</div>
            </div>
            <div className="stat-card-2">
              <div className="stat-number-2">98.25%</div>
              <div className="stat-label-2">First Time Payer Rate</div>
            </div>
            <div className="stat-card-2">
              <div className="stat-number-2">99%</div>
              <div className="stat-label-2">Clients Satisfaction 4.8 Stars Rating</div>
            </div>
            <div className="stat-card-2">
              <div className="stat-number-2">97%</div>
              <div className="stat-label-2">Claims Finalized in First 15 Days</div>
            </div>
            <div className="stat-card-2">
              <div className="stat-number-2">99%</div>
              <div className="stat-label-2">Same Day Billing</div>
            </div>
            <div className="stat-card-2">
              <div className="stat-number-2">15-30%</div>
              <div className="stat-label-2">Revenue Increase</div>
            </div>
          </div>
        </div>
      </section>

      {/* Dedicated Team Section */}
      <section className="dedicated-team-section">
        <div className="container">
          <div className="team-header">
            <h2 className="team-title">
              Dedicated Certified Medical Biller & Manager <span className="highlight">For Your Practice</span>
            </h2>
            <p className="team-description">
              Oxymed Billing Solutions works with all specialties. Each practice is assigned with a dedicated certified 
              medical biller and billing manager who are well experienced and knowledgeable with their specialty, ensuring 
              precise, efficient, and personalized billing support. We are proud to be among the first to start a tasking 
              our approach to the unique needs of your practice. Depending on your patient volume and complexity, your 
              account may be managed by one or more skilled billers, all working under the supervision of a Medical Billing 
              Supervisor. Your dedicated team includes a biller, supervisor, and billing manager, forming a structured system 
              that optimizes every aspect of your revenue cycle.
            </p>
          </div>
          <div className="team-features-grid">
            <div className="team-feature-card">
              <div className="team-feature-icon">🎯</div>
              <h3 className="team-feature-title">Specialty-Focused Expertise</h3>
              <p className="team-feature-description">
                Your team understands the billing and coding workflows, payment requirements, and nuances of your specialty.
              </p>
            </div>
            <div className="team-feature-card">
              <div className="team-feature-icon">✅</div>
              <h3 className="team-feature-title">Improved Accuracy</h3>
              <p className="team-feature-description">
                Superiority over existing claims due to automated denials, reducing errors and denials.
              </p>
            </div>
            <div className="team-feature-card">
              <div className="team-feature-icon">⚡</div>
              <h3 className="team-feature-title">Efficient Revenue Management</h3>
              <p className="team-feature-description">
                Streamlined processes accelerate reimbursement and maximize cash flow.
              </p>
            </div>
            <div className="team-feature-card">
              <div className="team-feature-icon">🤝</div>
              <h3 className="team-feature-title">Single Point of Contact</h3>
              <p className="team-feature-description">
                Your dedicated billing manager acts as your liaison, providing updates, reports, and feedback to your accounts.
              </p>
            </div>
            <div className="team-feature-card">
              <div className="team-feature-icon">📈</div>
              <h3 className="team-feature-title">Scalable & Flexible Support</h3>
              <p className="team-feature-description">
                Our team adapts to your practice's growth, seasonal fluctuations, or increased patient volume.
              </p>
            </div>
            <div className="team-feature-card">
              <div className="team-feature-icon">🇺🇸</div>
              <h3 className="team-feature-title">National Coverage</h3>
              <p className="team-feature-description">
                We provide coverage for providers billing support for providers across all states.
              </p>
            </div>
          </div>
        </div>
      </section>
        <section className="software-partners-section">
        <div className="container">
          <div className="partners-header">
            <h2 className="partners-title">
              Top Medical Billing Software <span className="highlight">We Partner With</span>
            </h2>
            <p className="partners-description">
              Whether you use Epic, Cerner, Athenehealth, eClinicalWorks, or any other EHR system, our certified team 
              knows them all inside and out. We adapt to your workflow seamlessly to ensure accurate billing and 
              maximum reimbursement.
            </p>
          </div>
          <div className="partners-logos">
            <div className="logo-item">ECW</div>
            <div className="logo-item">Office Ally</div>
            <div className="logo-item">RXNT</div>
            <div className="logo-item">TherapyNotes</div>
            <div className="logo-item">Experity</div>
            <div className="logo-item">SimplePractice</div>
            <div className="logo-item">ModMed</div>
            <div className="logo-item">Tebra</div>
            <div className="logo-item">Allora</div>
            <div className="logo-item">Ensora Health</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">
              Learn How Providers Care Can Help <span className="highlight">Your Business Thrive!</span>
            </h2>
            <button className="cta-button">Schedule a Demo →</button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-header">
            <div className="faq-badge">FAQ</div>
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <p className="faq-description">
              Find quick answers to the most common questions about our services, features, and how we can support your business. 
              If you need more details, our team is always here to help.
            </p>
          </div>
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">
                <span>What makes Oxymed Billing Solutions different from other medical billing companies?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                We provide dedicated account managers, specialty-focused expertise, and transparent reporting with 98%+ 
                claims approval rate. Our team becomes an extension of your practice.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>Can you work with my existing EHR or practice management software?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Yes! We integrate seamlessly with all major EHR systems including Epic, Cerner, Athenahealth, eClinicalWorks, 
                and many more.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>What specialties do you serve?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                We serve over 15+ specialties including Cardiology, Neurology, Pediatrics, Dermatology, Mental Health, 
                and many more.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>How soon can my practice start after signing up?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Most practices can start within 7-14 days after signing up, depending on the complexity of your setup 
                and data migration needs.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>Are you HIPAA-compliant?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Yes, we are fully HIPAA-compliant with strict security protocols to protect patient data and ensure privacy.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>Do you provide reports and analytics?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Yes, we provide comprehensive, data-driven reports that uncover performance trends and highlight 
                opportunities to improve your operations.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>How much do your medical billing services cost?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Our pricing is customized based on your practice size, specialty, and volume. Contact us for a free 
                personalized quote.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>Do you offer credentialing and enrollment services?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Yes, we provide comprehensive medical credentialing services to get your providers credentialed quickly 
                with payers and insurance networks.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>Do you handle claim denial and follow-up?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Absolutely! We proactively identify, analyze, and resolve claim denials with precision to maximize 
                your reimbursement.
              </div>
            </div>
            <div className="faq-item">
              <div className="faq-question">
                <span>How can I get started with Oxymed Billing Solutions?</span>
                <button className="faq-toggle">+</button>
              </div>
              <div className="faq-answer">
                Simply schedule a demo with our team, and we'll guide you through the onboarding process and create 
                a customized plan for your practice.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="trust-badges-section">
        <div className="container">
          <div className="badges-grid">
            {/* <div className="badge-card">
              <div className="badge-rating">4.8 ⭐⭐⭐⭐⭐</div>
              <div className="badge-label">Client Rating</div>
            </div> */}
            <div className="badge-card">
              <div className="badge-icon">✓</div>
              <div className="badge-label">ACCREDITED BUSINESS</div>
            </div>
            <div className="badge-card">
              <div className="badge-icon">🔒</div>
              <div className="badge-label">HIPAA COMPLIANT</div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;